import { KratosTokens } from '../types';

export function addKratosTokens(a: Partial<KratosTokens> = {}, b: Partial<KratosTokens> = {}): KratosTokens {
    return mergeKratosTokens(a, b, (x, y) => x + y);
}

export function subtractKratosTokens(a: Partial<KratosTokens> = {}, b: Partial<KratosTokens> = {}): KratosTokens {
    return mergeKratosTokens(a, b, (x, y) => x - y);
}

/**
 * PRIVATE
 */

function mergeKratosTokens(
    a: Partial<KratosTokens> = {},
    b: Partial<KratosTokens> = {},
    operation: (x: number, y: number) => number,
): KratosTokens {
    return {
        break: operation(a.break ?? 0, b.break ?? 0),
        black: operation(a.black ?? 0, b.black ?? 0),
        fire: operation(a.fire ?? 0, b.fire ?? 0),
        hope: operation(a.hope ?? 0, b.hope ?? 0),
        opening: operation(a.opening ?? 0, b.opening ?? 0),
        closing: operation(a.closing ?? 0, b.closing ?? 0),
        rouse: operation(a.rouse ?? 0, b.rouse ?? 0),
    };
}
